import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { Picture } from '@beef/smart-kit';
import { Text } from '@beef/ui-kit';

import styles from './styles.pcss';
import { DetailsProps } from '../../types';

const cn = classNames.bind(styles);

export const Details: FC<DetailsProps> = ({
  tariffImage,
  tariffSource,
  tariffColor,
  tariffTitle,
  priceSlot,
  menuSlot,
}) => (
  <div className={cn('wrap')}>
    <div className={cn('image')} style={{ backgroundColor: tariffColor }}>
      {tariffImage && (
        <Picture className={cn('image-pic')} source={tariffSource} src={tariffImage} />
      )}
    </div>
    <div className={cn('description')}>
      <div className={cn('title')}>
        <Text size="size4-m">{tariffTitle}</Text>
      </div>
      {priceSlot}
      {menuSlot}
    </div>
  </div>
);
